import React from 'react';
import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon
} from 'reactstrap';

import { getCommonGround, submitCommonGround } from '../../actions/commongroundAction';
import { doSubmitPhone } from '../../actions/saleActions';
import { doSentLinkVerificationEmail, doFetchProfile, doFetchCurrencyRate } from '../../actions/authAction';
import { CommonGroundLogin, SuccessPage, CGContainer } from '../CommonGroundPage';

import { isINA_Phone, isNumeric } from '../../helpers/regex';
import { addError, hasError } from '../../utils/Helpers';
import { FormFeedback } from '../../components/Forms';
import { ASSET_IMAGE } from '../../config'

const AlertErrorUnverifiedMsg = ({onClick, disabled}) => (
  <CGContainer
    textTop = "Please check your e-mail to verify your account. Simply click the link given on the email to complete this process."
    buttonVerif = "Send Verification Email"
    onClick = {onClick}
    disabled={disabled}
    textBottom="Please refresh this page once you are verified"
  />
)

class ParticipateForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedLocations: null,
      _phoneNumber: '',
      _isFetch: false,
      _balance: '',
      _roles: [],
      _location: 'Common Grounds City Walk',
      _error: null,
      _newPhoneNumber: '',
      _status_code: null
    }
  }

  componentDidMount() {
    this.props.getCommonGround();

    const { userdata, isLogged } = this.props.dataAuth;
    if(isLogged){
      if(userdata.status_code !== 200) this.props.fetchProfile();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { userdata } = this.props.dataAuth;
    const { dataOtp } = this.props;

    if(prevProps.dataAuth.userdata.isFetch && prevProps.dataAuth.userdata.isFetch !== userdata.isFetch){
      this.setState({
        _roles: userdata.roles
      })
    }

    if(prevProps.dataOtp.isFetch && prevProps.dataOtp.isFetch !== dataOtp.isFetch) {
      const { status_code } = dataOtp;
      const errors = {};
      const { id } = this.props.dataCommonGround.commonground.data;
      const { _location } = this.state;

      const payload = {
        raffle_id: id,
        short_note: _location
      }

        if(status_code === 501)
          errors['mobile_number'] = addError(errors, 'mobile_number', 'You entered same phone number!')
        if(status_code === 502)
         errors['mobile_number'] = addError(errors, 'mobile_number', 'This number has been taken.')
        if(status_code === 200) {
          this.props.submitCommonGround(payload);
        }

        this.setState({
          _status_code: dataOtp.status_code,
          _error:{
            ...this.state._error,
            errors
          }
        })
    }
  }

  handleValueChange(event) {
    this.setState({_newPhoneNumber: event.target.value});
  }

  //validation form
  _validationForm() {
    let errors = {};
    const { dataAuth } = this.props;
    if(!dataAuth.userdata.roles.includes('seller') && !isNumeric(this.state._newPhoneNumber))
      errors['mobile_number'] = addError(errors, 'mobile_number', 'This field must be numeric.');

    return errors;
  }

  _hasErrorForm(errors){
    return Object.keys(errors).length > 0;
  }

  handleSubmit = () => {
    const { id } = this.props.dataCommonGround.commonground.data;
    const { _location, _newPhoneNumber } = this.state;
    const errors = this._validationForm();

    if(this._hasErrorForm(errors)) {
      this.setState({
        _error: {
          ...this.state._error,
          errors
        }
      })
    } else {
      const payload = {
        raffle_id: id,
        short_note: _location
      }
      if (!_newPhoneNumber) {
        this.props.submitCommonGround(payload);
      } else {
        this.props.doSubmitPhone({mobile_number: `+62${isINA_Phone(_newPhoneNumber)}`});
      }
    }
  }

  _onSentEmail = () => {
    this.props.submit();
    setTimeout(()=>{
      if(this.props.isOpen===true)
      this.props.onToggle();
      this.props.onSuccess();
    },300)
  }

  renderContent() {
    const { dataAuth } = this.props;
    const { _location, _newPhoneNumber } = this.state;

    return(
      <div className="cg-container">
        <div className="CGForm">
          <div className="CG-title-wrapper">
            <p>Fill out the form below to participate in our sneaker-raffle</p>
          </div>
          <FormGroup className="input-wrapper">
            {/* <div className="location-wrapper">
              <Label className="CG-Label">Location</Label>
                <Select
                  className="CG-Select"
                  options={locations}
                  value={selectedLocations}
                  onChange={this.handleChange}
                />
            </div> */}
            <div className="email-wrapper">
              <Label className="CG-Label">Locations</Label>
                <InputGroup>
                    <Input className="CG-Input" value={_location} disabled/>
                </InputGroup>
            </div>
            {/* <div className="email-wrapper">
              <Label className="CG-Label">Email</Label>
                <InputGroup>
                    <Input className="CG-Input"/>
                </InputGroup>
            </div> */}
            {
              dataAuth.userdata.roles.includes('seller') ? null :
              <div className="phone-wrapper">
              <Label className="CG-Label">Active Mobile Number</Label>
                <InputGroup className={classNames("group-phone", {"is-invalid": hasError(this.state._error && this.state._error.errors, 'mobile_number')})}>
                  <InputGroupAddon addonType="prepend">+62</InputGroupAddon>
                  <Input className="CG-Phone-Input" value={_newPhoneNumber} onChange={this.handleValueChange.bind(this)}/>
                  </InputGroup>
                  <FormFeedback errors={this.state._error && this.state._error.errors} field="mobile_number"/>
            </div>
            }
          </FormGroup>
            <Button className="CG_btn" onClick={this.handleSubmit}>SUBMIT</Button>
        </div>
      </div>
    )
  }

  renderError() {
    return (
      <CGContainer
        textTop="Your entry has been recorded. You cannot enter another submission.
        Thank you for participating."
      />
    )
  }

  renderNotFound() {
    return (
    <CGContainer
      textTop="This event has been concluded. We’ll be announcing another events in the coming future."
      textCenter="Thank you for participating."
    />
    )
  }

  renderTextTop() {
    return (
      <div>
        <p>Congratulations! Your entry has been accepted, winners will be randomly picked and announced on <span><strong className="strong-text">common.grounds.coffee</strong></span> Instagram LIVE</p>
      </div>
    )
  }

  renderTextCenter() {
    return (
      <div>
        <p><span><strong style={{fontWeight: '900', color: 'black'}}><i>Please DO NOT lose the raffle ticket as it will be asked to prove your eligibility.</i></strong></span></p>
      </div>
    )
  }
  render() {
    const { dataCommonGround, dataAuth } = this.props;

    if (!dataAuth.isLogged) {
      return (
        <CommonGroundLogin
        onClick={e=> this.props.history.replace({ pathname: '/login', search: "?next=/promo/common-grounds" })}
        />
      )
    }

    if (dataAuth.userdata.roles.includes('unverified_user')){
      return (
        <AlertErrorUnverifiedMsg
          onClick={this._onSentEmail}
          disabled={dataAuth.userSentLinkEmailVerify.isSubmit}
        />
      )
    }

    if (dataCommonGround.commonground.status_code === 500) {
      return (
        this.renderError()
        )
      }
    if (dataCommonGround.commonground.status_code === 404) {
      return (
        this.renderNotFound()
      )
    }
    if(dataCommonGround.submitCommonGround.status_code === 200) {
      return (
        <SuccessPage
          onClick={e=>this.props.history.push('/')}
          textTop={this.renderTextTop()}
          textCenter={this.renderTextCenter()}
          textBottom="You can now close/leave this page. Please continue enjoying your fresh brew of Common Grounds Coffee or browse Kick Avenue sneakers collections by clicking the button below."
          img={`${ASSET_IMAGE}/assets-image/common-ground-coffee.png`}
          textButton="DONE"
        />
      )
    }
    return (
      this.renderContent()
    )
  }
}

const mapStateToProps = state => ({
    dataAuth: state.dataAuth,
    dataCommonGround: state.dataCommonGround,
    dataOtp: state.dataOtp.dataPhoneUser
  })

const mapDispatchToProps = dispatch => ({
    getCommonGround: () => dispatch(getCommonGround()),
    submitCommonGround: (payload) => dispatch(submitCommonGround(payload)),
    doSubmitPhone: (payload) => dispatch(doSubmitPhone(payload)),
    fetchProfile: () => dispatch(doFetchProfile()),
    doFetchCurrencyRate: (payload) => dispatch(doFetchCurrencyRate(payload)),
    submit : ()=> dispatch(doSentLinkVerificationEmail())
  })

export default connect(mapStateToProps, mapDispatchToProps)(ParticipateForm);
